import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CountryForm from '../containers/CountryFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class CountryEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CountryEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('country_route_edit')} />
          <CountryForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CountryEditScreen;

Logger.log('silly', `CountryEditScreen loaded.`);
